import { haptic } from './touchdevice';

/**
 * On-screen joystick for touch phones (window.IS_TOUCH_PHONE, set in index.html).
 * Feeds GameState's WASDController through `analog` (camera-relative input space: x right, y forward).
 */
const RADIUS = 60; // joystick travel in css px (virtual viewport units)

class _TouchControls {
  readonly enabled = !!(window as any).IS_TOUCH_PHONE;
  analog: { x: number; y: number } | null = null;
  private root: HTMLElement | null = null;

  show() {
    if (!this.enabled) return;
    if (!this.root) this.build();
    this.root!.style.display = 'block';
  }

  hide() {
    if (this.root) this.root.style.display = 'none';
    this.analog = null;
  }

  private build() {
    const root = document.createElement('div');
    root.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:900;touch-action:none;';

    const base = document.createElement('div');
    base.style.cssText = `position:absolute;left:40px;bottom:210px;width:${RADIUS * 2}px;height:${RADIUS * 2}px;` +
      'border-radius:50%;background:rgba(255,255,255,0.15);border:2px solid rgba(255,255,255,0.4);' +
      'pointer-events:auto;touch-action:none;';
    const knob = document.createElement('div');
    knob.style.cssText = 'position:absolute;left:50%;top:50%;width:50px;height:50px;margin:-25px 0 0 -25px;' +
      'border-radius:50%;background:rgba(255,255,255,0.5);pointer-events:none;';
    base.appendChild(knob);

    let pointerId: number | null = null;
    const move = (e: PointerEvent) => {
      const r = base.getBoundingClientRect();
      let dx = e.clientX - (r.left + r.width / 2);
      let dy = e.clientY - (r.top + r.height / 2);
      const len = Math.hypot(dx, dy);
      if (len > RADIUS) {
        dx = (dx / len) * RADIUS;
        dy = (dy / len) * RADIUS;
      }
      knob.style.transform = `translate(${dx}px,${dy}px)`;
      // small dead zone so a resting thumb doesn't creep
      this.analog = len < 8 ? null : { x: dx / RADIUS, y: -dy / RADIUS };
    };
    const release = (e: PointerEvent) => {
      if (e.pointerId !== pointerId) return;
      pointerId = null;
      knob.style.transform = '';
      this.analog = null;
    };
    base.addEventListener('pointerdown', (e) => {
      if (pointerId !== null) return;
      pointerId = e.pointerId;
      haptic(8);
      try {
        base.setPointerCapture(e.pointerId);
      } catch {
        // pointer already gone; the drag simply ends on the next pointerup
      }
      move(e);
    });
    base.addEventListener('pointermove', (e) => {
      if (e.pointerId === pointerId) move(e);
    });
    base.addEventListener('pointerup', release);
    base.addEventListener('pointercancel', release);

    root.appendChild(base);
    document.body.appendChild(root);
    this.root = root;
  }
}

export const TouchControls = new _TouchControls();
